/* eslint-disable max-len */
import * as XLSX from 'xlsx';
import { jsPDF as JSpdf } from 'jspdf';

import moment from 'moment';

import logo from '../assets/images/kitegateway_icon_dark.png';

export const handleXcl = (headers, xclData, file, timezone) => {
  const time = moment.utc().add('hours', timezone.offset).format('DD-MM-YYYY');
  const headerTitles = headers.filter((column) => column.xlsx).map((header) => header.title);
  const dataExtract = xclData.map((row) => headers.filter((column) => column.xlsx).map((header) => row[header.dataIndex]));

  dataExtract.unshift(headerTitles);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(dataExtract);
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${file} - ${time}.xlsx`);
};

export const handlePdf = (headers, data, file, timezone) => {
  const time = moment(Date.now()).utc().add('hours', timezone.offset).format('DD-MM-YYYY');
  const doc = new JSpdf({ orientation: 'landscape' });
  doc.addImage(logo, 'PNG', 0, 0, 43.85, 17.06);
  doc.text(`${file} - ${time}`, 50, 10);
  const headerTitles = headers.filter((column) => column.pdf).map((header) => header.title);
  const dataExtract = data.map((row) => headers.filter((column) => column.pdf).map((header) => row[header.dataIndex]));
  doc.autoTable({
    margin: { top: 19, left: 1, right: 1 },
    head: [headerTitles],
    body: dataExtract,
  });
  doc.save(`${file} - ${time}.pdf`);
};

export const generatePdfData = (data, columns, callback = undefined) => data.map((item) => {
  // process data from headers
  let row = {};
  columns.filter((column) => column.pdf).forEach((header) => {
    row[header.dataIndex] = typeof item[header.dataIndex] === 'object' ? item[header.dataIndex].name : item[header.dataIndex];
    if (callback && Array.isArray(item[header.dataIndex])) {
      row = callback(row, item[header.dataIndex], header.dataIndex);
    }
  });
  return row;
});

export const generateXclData = (data, columns, callback = undefined) => data.map((item) => {
  // process data from headers
  let row = {};
  columns.filter((column) => column.xlsx).forEach((header) => {
    row[header.dataIndex] = typeof item[header.dataIndex] === 'object' ? item[header.dataIndex].name : item[header.dataIndex];
    if (callback && Array.isArray(item[header.dataIndex])) {
      row = callback(row, item[header.dataIndex], header.dataIndex);
    }
  });
  return row;
});
